// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    hmr: false,

    val_entidad: "PNSU",

    //Valores dinamicas
    // ip_servidor_ws: "http://ws-gestion",
    ip_servidor_ws: "https://repo.gestion.pnsu.gob.pe",
    //val_servidor: "http://ws-gestion:8080/",


    val_servidor: "https://s1.gestion.pnsu.gob.pe/", //PROD
    //val_servidor: "http://10.165.7.128:8080/",
    //val_servidor: "http://localhost:8080/",
    //val_servidor: "http://10.165.14.130:8080/",
    //val_servidor: "http://10.165.8.210:8080/",


    //val_servidor: "http://10.165.7.89:8080/",
    //val_servidor: "https://s0.devgestion.pnsu.gob.pe/",
    // val_servidor_login: "http://127.0.0.1:8081/",
    // val_servidor_login: "https://s2.gestion.pnsu.gob.pe/",

    //val_servidor_upload_drive: "http://localhost:8001/",

    //val_servidor_upload_drive: "http://10.165.7.231:8001/uploads-drive",

    val_servidor_upload_drive: "https://node.gestion.pnsu.gob.pe/",

    // val_servidor_marcacion_intranet: "http://ws-gestion:8084/",
    val_servidor_marcacion_intranet: "https://s3.gestion.pnsu.gob.pe/",

    // val_url_archivos: "D:\\TEMP",
    val_url_archivos: "/var/www/html/archive",

    val_id_folder_google_drive_gestion_solicitudes: "1ADfxQAkpWeNEYrUuojTJwHXIOBW_nW_y",
    val_id_folder_google_drive_gestion_solicitudes_comision_servicio: "1ADfxQAkpWeNEYrUuojTJwHXIOBW_nW_y",
    val_id_folder_google_drive_gestion_solicitudes_licencias: "1ADfxQAkpWeNEYrUuojTJwHXIOBW_nW_y",
    val_id_folder_google_drive_gestion_solicitudes_permisos: "1ADfxQAkpWeNEYrUuojTJwHXIOBW_nW_y",
    val_id_folder_google_drive_gestion_solicitudes_salud: "1ADfxQAkpWeNEYrUuojTJwHXIOBW_nW_y",
    val_id_folder_google_drive_gestion_solicitudes_trabajo_remoto: "1ADfxQAkpWeNEYrUuojTJwHXIOBW_nW_y",
    val_id_folder_google_drive_gestion_solicitudes_compensacion: "1ADfxQAkpWeNEYrUuojTJwHXIOBW_nW_y",
    val_id_folder_google_drive_gestion_solicitudes_medida_cautelar: "1ADfxQAkpWeNEYrUuojTJwHXIOBW_nW_y",
    val_id_folder_google_drive_gestion_solicitudes_teletrabajo: "1ADfxQAkpWeNEYrUuojTJwHXIOBW_nW_y",

    // ip_fija_panama: "190.236.204.171",
    ip_fija_panama: "167.249.10.194",
    ip_fija_olaechea: "190.12.91.114",
    ip_fija_huarmaca: "181.176.215.38",

    tokenCAC: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkb2N1bWVudG9pZGVudGlkYWQiOiIwMDAwMDAwMCJ9.KEe4YRoBg0b3ZJP9z1lCY8LaJ3RpVjuvA08MVlms22U',
    clave: 'val_cac'

};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
